import api from './api';

export interface User {
  id: number;
  email: string;
  first_name: string;
  last_name: string;
  full_name: string;
  role: 'admin' | 'therapist';
  tenant_id: number | null;
  phone: string | null;
  license_number: string | null;
  is_active: boolean;
  is_2fa_enabled: boolean;
  created_at: string;
  updated_at: string;
}

export interface UserCreate {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
  role: 'admin' | 'therapist';
  tenant_id?: number;
  phone?: string;
  license_number?: string;
}

export interface UserUpdate {
  email?: string;
  first_name?: string;
  last_name?: string;
  role?: 'admin' | 'therapist';
  tenant_id?: number;
  phone?: string;
  license_number?: string;
  is_active?: boolean;
}

export const userService = {
  async getUsers(tenantId?: number): Promise<User[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/users/${params}`);
    return response.data;
  },

  async getUser(userId: number): Promise<User> {
    const response = await api.get(`/users/${userId}`);
    return response.data;
  },

  async createUser(userData: UserCreate): Promise<User> {
    const response = await api.post('/users/', userData);
    return response.data;
  },

  async updateUser(userId: number, userData: UserUpdate): Promise<User> {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  async deleteUser(userId: number): Promise<void> {
    await api.delete(`/users/${userId}`);
  },
};